<template>
  <div>
    <Breadcrumbs main="Firmware" title="Update Data" />
    
    <div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

              <div ref="spreadsheetContainer" class="spreadsheet-wrapper"></div>
              <button @click="submit" class="btn btn-primary mt-3 float-end">Update</button>

            </div>
          </div>
        </div>
      </div>
    </div>
 

  </div>
</template>

<script>
import jspreadsheet from 'jspreadsheet-ce'
import 'jspreadsheet-ce/dist/jspreadsheet.css'
import 'jsuites/dist/jsuites.css'

export default {
  data() {
    return {
      spreadsheetInstance: null,
      token: '',
      rawData: [
        ['SN001', '8986001201112754154', '748789042116560', '', '', 'VI+Airtel'],
        ['SN002', '8986001201112131644', '956789042111445', '', '', ''],
        ['SN003', '8986001201112134732', '856789042111537', '', '', ''],
        ['SN004', '8986001201112136745', '856789042111237', 'SIM11223', 'SIM33211', 'Airtel+BSNL']
      ]
    }
  },

  mounted() {
    this.initializeSpreadsheet()
    
  },

  methods: {
    initializeSpreadsheet() {
      if (this.spreadsheetInstance) {
        this.spreadsheetInstance.destroy()
      }

      this.spreadsheetInstance = jspreadsheet(this.$refs.spreadsheetContainer, {
        data: this.rawData,
        columns: [
          { title: 'Serial Number', width: 170, readOnly: true },
          { title: 'ICCID', width: 220, },
          { title: 'IMEI', width: 210 },
          { title: 'SIM 1', width: 150 },
          { title: 'SIM 2', width: 150 },
          { title: 'Operator', width: 170 }
        ],
        minDimensions: [6, this.rawData.length]
      })
    },

    submit() {
      const updatedData = this.spreadsheetInstance.getData()
      console.log('Updated spreadsheet data:', updatedData)
    }

  }
}
</script>


<style>
  .spreadsheet-wrapper {
    overflow-x: auto;
    max-width: 100%;
    border: 1px solid #edefee;
  }
/* 
  .jexcel > tbody > tr > td,
  .jexcel > thead > tr > td {
    height: 50px !important;
    line-height: 50px !important;
  } */

  .jexcel {
    font-family: 'Segoe UI', Tahoma, sans-serif;
    font-size: 18px;
    border: 1px solid #d0d0d0;
    border-collapse: collapse;
  }

  /* Header Row */
  .jexcel thead td {
    background-color: #e6f0ff;
    font-weight: bold;
    text-align: center;
    border: 1px solid #ccc;
    color: #10b859;
    height: 38px;
    padding: 6px;
  }

  /* Table Body Cells */
  .jexcel tbody td {
    border: 1px solid #ccc;
    height: 38px;
    padding: 6px;
    vertical-align: middle;
    background-color: #fff;
    color: #000;
  }

  /* Alternating Row Backgrounds */
  .jexcel tbody tr:nth-child(even) td {
    background-color: #f9f9f9;
  }

  /* Focused Cell Style */
  .jexcel td.selected {
    border: 2px solid #1a73e8 !important;
    background-color: #e8f0fe !important;
  }

  /* Remove Default Outline */
  .jexcel td:focus {
    outline: none;
  }
  
</style>